import {
  TITLE,
  TITLE_DATA_STANDARDS,
} from 'jl-design-system/form/fields';

export default function titleField(useTitleDropdown) {
  const titleFieldConfig = useTitleDropdown ? TITLE_DATA_STANDARDS : TITLE;

  if (useTitleDropdown) {
    titleFieldConfig.className = 'fieldSmall';
  }

  return titleFieldConfig;
}
